import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './override.css';
import './components/UI/Popover/popover-bwai.css';
import './components/UI/TooltipDefinition/hover-tooltip-bwai.css';
import './alert-bwai.css';
import './colors.css';
import './components/chrome-bwai.css';
import './assets/icons/flaticon.css'
import registerServiceWorker from './registerServiceWorker'
// import { unregister } from './registerServiceWorker';
import { applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import Root from './container/Root';
import configureStore from './utils/configureStore';
import 'bootstrap/dist/css/bootstrap.min.css';

// import  { socketConnection }  from './socketClient';

// import userTracking from '../src/utils/userTracking';

const middleware = applyMiddleware(thunk);

const store = configureStore(middleware);

ReactDOM.render(<Root store={store} />, document.getElementById('root'));

export { store };
registerServiceWorker();

// userTracking.setGeoData();

// socketConnection.track();